import type { postTestimonialsCreateResponse } from '@lt/api/dist/methods/testimonials/types';
import { api } from 'src/api';
import type { TestimonialsFormValues } from 'src/routes/TestimonialsForm/types';
import type { AxiosError } from 'axios';
import { mapTestimonialsFormValuesToRequest } from 'src/routes/TestimonialsForm/utils';
import { useState } from 'react';

export type UseTestimonialsCreate = ReturnType<typeof useTestimonialsCreate>;

// export const useTestimonialsCreate = (orderId?: string) => {
export const useTestimonialsCreate = () => {
  const [testimonialsCreateResponse, setTestimonialsCreateResponse] = useState<
    postTestimonialsCreateResponse | undefined
  >(undefined);

  const handleTestimonialsCreate = async (
    values: TestimonialsFormValues,
  ): Promise<postTestimonialsCreateResponse | AxiosError> => {
    try {
      // const data = mapTestimonialsFormValuesToRequest(values, orderId);
      const data = mapTestimonialsFormValuesToRequest(values);

      if (!data) {
        throw new Error('create testimonials not success');
      }

      const response = await api.postTestimonialsCreate(data);

      if (!response.success) {
        throw new Error('create testimonials not success');
      }

      return response;
    } catch (e: any) {
      console.dir(e);
      return e;
    }
  };

  return {
    handleTestimonialsCreate,
    testimonialsCreateResponse,
    setTestimonialsCreateResponse,
  };
};
